function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import Fade from "@mui/material/Fade";
import { useToggle } from "@react-hookz/web";
import React from "react";
import { SwitchTransition } from "react-transition-group";
import { useSdkContext } from "~/components/contexts";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { ActionComponent } from "~/components/newsletter/newsletter-widget/sign-up-newsletter/enums";
import { useAction } from "~/components/newsletter/newsletter-widget/sign-up-newsletter/hooks";
var IconCheckboxChecked = function IconCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z",
    fill: "#4585FF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4585FF",
    d: "M17 1v16H1V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.692 12.115.004-.004-.004.004zM14.332 5l.668.625-7.56 7.074-.338.301L3 9.162l.668-.625 3.442 3.22L14.332 5z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
};
IconCheckboxChecked.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconCheckboxCheckedOff = function IconCheckboxCheckedOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17 1v16H1V1h16zm-1-1H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2z",
    fill: "#CCC",
    fillRule: "evenodd"
  }));
};
IconCheckboxCheckedOff.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};
import { DescriptionDisplay } from "./description-display";
import { ActionAndTermsContainer, ActionContainer, AgreementCheckboxContainer, AgreementContainer, AgreementDescription, Bottom, Container, ContentContainer, FadeContainer, Main, MobileContentContainer, StyledTitleDisplay, SummaryContainer, TermAndConditionContainer, TermAndConditionLink, TitleAndDescriptionContainer } from "./styles";
import { SummaryDisplay } from "./summary-display";
import { TitleDisplay } from "./title-display";
export const SignUpNewsletter = ({
  isDisableSignupButtonMouseOver = false,
  isShowOverlaySignUp = false,
  onSuccess,
  ...props
}) => {
  const {
    handleRoutePush,
    handleTrackGA4
  } = useSdkContext();
  const [isAgreedReceiveMarketing, setIsAgreedReceiveMarketing] = useToggle(false);
  const {
    campaignName
  } = useNewsletterContext();
  const renderCheckbox = () => {
    if (isAgreedReceiveMarketing) {
      return /*#__PURE__*/React.createElement(IconCheckboxChecked, null);
    }
    return /*#__PURE__*/React.createElement(IconCheckboxCheckedOff, {
      "data-qa": "render-checkbox"
    });
  };
  const {
    actionComponent,
    handleRenderActionComponent
  } = useAction({
    isAgreedReceiveMarketing,
    isDisableSignupButtonMouseOver,
    isShowOverlaySignUp,
    onSuccess
  });
  const handleRenderAgreement = () => /*#__PURE__*/React.createElement(AgreementContainer, {
    "data-qa": "handle-render-agreement"
  }, /*#__PURE__*/React.createElement(AgreementCheckboxContainer, {
    onClick: setIsAgreedReceiveMarketing
  }, renderCheckbox()), /*#__PURE__*/React.createElement(AgreementDescription, null, `By submitting, you consent to receiving marketing emails from SCMP. If you don't want these, tick here`));
  const handleRenderTabletUpContent = () => {
    const handleRenderCondition = () => {
      if (actionComponent === ActionComponent.OverlaySignUpButton || actionComponent === ActionComponent.SignUpButton) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SummaryContainer, null, /*#__PURE__*/React.createElement(SummaryDisplay, null)), /*#__PURE__*/React.createElement(TitleAndDescriptionContainer, null, /*#__PURE__*/React.createElement(TitleDisplay, null), /*#__PURE__*/React.createElement(DescriptionDisplay, null)));
      }
      return handleRenderAgreement();
    };
    return /*#__PURE__*/React.createElement(ContentContainer, {
      "data-qa": "handle-render-tablet-up-content"
    }, /*#__PURE__*/React.createElement(SwitchTransition, {
      mode: "out-in"
    }, /*#__PURE__*/React.createElement(Fade, {
      key: String(actionComponent === ActionComponent.OverlaySignUpButton || actionComponent === ActionComponent.SignUpButton),
      timeout: 500
    }, /*#__PURE__*/React.createElement(FadeContainer, null, handleRenderCondition()))));
  };
  const handleRenderMobileContent = () => {
    const handleRenderCondition = () => {
      if (actionComponent === ActionComponent.OverlaySignUpButton || actionComponent === ActionComponent.SignUpButton) {
        return /*#__PURE__*/React.createElement(DescriptionDisplay, null);
      }
      return handleRenderAgreement();
    };
    return /*#__PURE__*/React.createElement(MobileContentContainer, {
      "data-qa": "handle-render-mobile-content"
    }, /*#__PURE__*/React.createElement(SummaryContainer, null, /*#__PURE__*/React.createElement(SummaryDisplay, null)), /*#__PURE__*/React.createElement(StyledTitleDisplay, null), /*#__PURE__*/React.createElement(SwitchTransition, {
      mode: "out-in"
    }, /*#__PURE__*/React.createElement(Fade, {
      key: String(actionComponent === ActionComponent.OverlaySignUpButton || actionComponent === ActionComponent.SignUpButton),
      timeout: 500
    }, /*#__PURE__*/React.createElement(FadeContainer, null, handleRenderCondition()))));
  };
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "sign-up-newsletter"
  }), /*#__PURE__*/React.createElement(Main, null, handleRenderTabletUpContent(), handleRenderMobileContent(), /*#__PURE__*/React.createElement(ActionAndTermsContainer, null, /*#__PURE__*/React.createElement(SwitchTransition, {
    mode: "out-in"
  }, /*#__PURE__*/React.createElement(Fade, {
    key: actionComponent,
    timeout: 500
  }, /*#__PURE__*/React.createElement(ActionContainer, null, handleRenderActionComponent()))))), /*#__PURE__*/React.createElement(Bottom, null, /*#__PURE__*/React.createElement(TermAndConditionContainer, null, "By registering, you agree to our", /*#__PURE__*/React.createElement(TermAndConditionLink, {
    href: "/terms-conditions",
    onClick: event => {
      event.preventDefault();
      handleTrackGA4({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/terms-conditions",
          internal_campaign: campaignName !== null && campaignName !== void 0 ? campaignName : "",
          message: "T&C",
          step: "1"
        },
        subcategory: ""
      });
      void handleRoutePush("/terms-conditions");
    }
  }, "T&C"), "and", /*#__PURE__*/React.createElement(TermAndConditionLink, {
    href: "/privacy-policy",
    onClick: event => {
      event.preventDefault();
      handleTrackGA4({
        action: "click",
        category: "promopopup",
        customized_parameters: {
          cta_type: "nl_signup",
          destination_url: "/privacy-policy",
          internal_campaign: campaignName !== null && campaignName !== void 0 ? campaignName : "",
          message: "Privacy Policy",
          step: "1"
        },
        subcategory: ""
      });
      void handleRoutePush("/privacy-policy");
    }
  }, "Privacy Policy"))));
};
SignUpNewsletter.displayName = "SignUpNewsletter";